const state = {
  currentEventId: -1,
  currentProductId: '',
  currentCategoryId: '',
  currentWatchedProduct: '',
};

const getters = {
  currentProductId(state) {
    return state.currentProductId;
  },
  currentEventId(state) {
    return state.currentEventId;
  },
  currentCategoryId(state) {
    return state.currentCategoryId;
  },
  currentWatchedProduct(state) {
    return state.currentWatchedProduct;
  },
};

const mutations = {
  setCurrentEventId(state, currentEventId) {
    state.currentEventId = currentEventId;
  },
  setCurrentProductId(state, currentProductId) {
    state.currentProductId = currentProductId;
  },
  setCurrentCategoryId(state, currentCategoryId) {
    state.currentCategoryId = currentCategoryId;
  },
  setCurrentWatchedProduct(sate, currentWatchedProduct) {
    state.currentWatchedProduct = currentWatchedProduct;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
